const rol = {
  admin: 1,
  staff: 4,
  center: 5,
}

export default rol
